<template>
  <router-view />
</template>

<script>
export default {
  name: 'father'
}
</script>

<style scoped>

</style>
